import { css } from 'lit'

// 各 phase 共用的 host 層 chrome（載入卡 / muted 文字）。從 survey-element.ts
// 抽出以維持該檔在 300 行上限內 —— 純 CSS 搬移、無邏輯改變。
export const hostStyles = css`
  /* 自訂元素預設是 inline；inline 問卷建立 block formatting context。
     phase 尺寸由 shadow DOM 內的 internal view modifier 決定，host 不再持有單一固定高度。 */
  :host([layout='inline']) {
    display: block;
  }
  /* Keyboard focus ring. Scoped to the Shadow DOM (the bare :focus-visible == *:focus-visible
     only matches widget-internal nodes), so it gives every interactive element a consistent
     accent ring regardless of the host page's (or lack of) focus styles. */
  :focus-visible {
    outline: 2px solid var(--mp-brand);
    outline-offset: 2px;
  }
  .muted { color: var(--mp-text-secondary); font-size: 14px; }
  .loading {
    border: 1px solid var(--mp-border-default);
    border-radius: 8px;
    background: var(--mp-bg-base);
    padding: 20px;
  }
`
